// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";

// App
import { DashboardApplicationDTO } from "../../DTO/DashboardApplicationDTO";

export class DashboardApplicationModel extends ModelBase<DashboardApplicationModel, DashboardApplicationDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public createdByUserId: string = "";
    @MobX.observable public statusId: string = "";
    @MobX.observable public statusName: string = "";
    @MobX.observable public lastSavedDate: Date = new Date();
    @MobX.observable public createdDate: Date = new Date();
    @MobX.observable public submittedDate: Date | null = null;
    @MobX.observable public rejectReasonId: string = "";
    @MobX.observable public rejectReasonDetail: string = "";
    @MobX.observable public isSubmitted: boolean = false;
    @MobX.observable public isDeleted: boolean = false;
    @MobX.observable public applicantUserStatus: string = "";

    @MobX.action
    public fromDto = (model: DashboardApplicationDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.createdByUserId = model.createdByUserId;
            this.statusId = model.statusId;
            this.statusName = model.statusName;
            this.lastSavedDate = model.lastSavedDate;
            this.createdDate = model.createdDate;
            this.submittedDate = model.submittedDate;
            this.rejectReasonId = model.rejectReasonId;
            this.rejectReasonDetail = model.rejectReasonDetail;
            this.isSubmitted = model.isSubmitted;
            this.isDeleted = model.isDeleted;
            this.applicantUserStatus = model.applicantUserStatus;
        }
    };
    @MobX.action
    public toDto = (): DashboardApplicationDTO => {
        let model: DashboardApplicationDTO = {
            id: this.id,
            createdByUserId: this.createdByUserId,
            statusId: this.statusId,
            statusName: this.statusName,
            lastSavedDate: this.lastSavedDate,
            createdDate: this.createdDate,
            rejectReasonId: this.rejectReasonId,
            rejectReasonDetail: this.rejectReasonDetail,
            submittedDate: this.submittedDate,
            isSubmitted: this.isSubmitted,
            isDeleted: this.isDeleted,
            applicantUserStatus: this.applicantUserStatus,
        };

        return model;
    };
}
